import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { QuestionRound, SelectedQuestionRound } from './hooks/useQuestionEngine';

interface QuestionState {
  questionRounds: QuestionRound[];
  selectedQuestionRounds: SelectedQuestionRound[];
}

const initialState: QuestionState = {
  questionRounds: [],
  selectedQuestionRounds: [],
};

export const questionSlice = createSlice({
  name: 'question',
  initialState,
  reducers: {
    setQuestionRounds: (state, action: PayloadAction<QuestionRound[]>) => {
      state.questionRounds = action.payload;
    },
    resetQuestionRounds: state => {
      state.questionRounds = [];
    },
    setSelectedQuestionRounds: (state, action: PayloadAction<SelectedQuestionRound[]>) => {
      state.selectedQuestionRounds = action.payload;
    },
    resetSelectedQuestionRounds: state => {
      state.selectedQuestionRounds = [];
    },
  },
});

export const {
  setQuestionRounds,
  resetQuestionRounds,
  setSelectedQuestionRounds,
  resetSelectedQuestionRounds,
} = questionSlice.actions;

export const selectQuestionRounds = (state: { question: QuestionState }) =>
  state.question.questionRounds;

export const selectSelectedQuestionRounds = (state: { question: QuestionState }) =>
  state.question.selectedQuestionRounds;

export default questionSlice.reducer;
